import { ReactComponent as XeroConnect } from '../../assets/xero-connect.svg';
import { useXeroConsentUrl } from '../../queries/use-xero-consent-url';

type ConnectToXeroProps = {
    onUrl?: (url: string) => void;
    autoRedirect?: boolean;
    callbackLocation?: string;
    disabled?: boolean;
};

function ConnectToXero({ onUrl, callbackLocation, autoRedirect = false, disabled = false }: ConnectToXeroProps): JSX.Element {
    const xeroConsentUrlQuery = useXeroConsentUrl();

    async function redirectToXero(): Promise<void> {
        const { data } = await xeroConsentUrlQuery.refetch();
        if (data) {
            if (callbackLocation) {
                localStorage.setItem('xero-redirect', callbackLocation);
            }
            if (onUrl) {
                onUrl(data.url);
            }
            if (autoRedirect) {
                window.location.href = data.url;
            }
        }
    }
    return (
        <button
            onClick={redirectToXero}
            // Disable this option while in demo mode.
            disabled={
                disabled ||
                (process.env.REACT_APP_MOCK_API === 'true' && process.env.REACT_APP_MOCK_USER === 'true') ||
                xeroConsentUrlQuery.isLoading
            }
        >
            <XeroConnect />
        </button>
    );
}
export default ConnectToXero;
